module.exports = "pegasus/assets/theme5/medium/6.jpg";